/*
 Initial state and properties
 */
 export const initialState = {
    mode:"POST",
    pickupsIdSelected:0,
    defaultDataPickups:null
 }
 /*
  Action types
  */
 export const SET_MODE = 'SET_MODE'
 export const SET_PICKUPS_ID = 'SET_PICKUPS_ID'
 export const SET_DEFAULT_DATA = 'SET_DEFAULT_DATA'
 /*
  Arrow function for change state
  */
 export const setMode = (payload) => ({
   type: SET_MODE,
   payload,
 });
 export const setPickupsId = (payload) => ({
  type: SET_PICKUPS_ID,
  payload,
})
export const setDefaultData = (payload) => ({
  type: SET_DEFAULT_DATA,
  payload,
})
 /*
  Reducer to describe how the state changed
  */
 export default function Reducer(state = initialState, { type, payload }) {
   switch (type) {
     case SET_MODE:
       return {
         ...state,
         mode: payload,
       }
       case SET_PICKUPS_ID:
        return {
          ...state,
        pickupsIdSelected: payload,
        }
        case SET_DEFAULT_DATA:
          return {
            ...state,
            defaultDataPickups: payload,
          }
     default:
       return state
   }
 }
 